import { deleteCookie, getCookieRaw, setCookie } from "./cookieUtils";

export interface BuyNowIntent {
  mappingCode: string;
  qty: number;
  createdAt: number;
}

const BUY_NOW_INTENT_COOKIE = "buy_now_intent";
const BUY_NOW_INTENT_COOKIE_DAYS = 1;
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const BUY_NOW_INTENT_MAX_AGE_MS =
  MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

const isBuyNowIntent = (value: unknown): value is BuyNowIntent => {
  if (!value || typeof value !== "object") return false;

  const intent = value as Partial<BuyNowIntent>;
  return (
    typeof intent.mappingCode === "string" &&
    intent.mappingCode.length > 0 &&
    typeof intent.qty === "number" &&
    intent.qty > 0 &&
    typeof intent.createdAt === "number"
  );
};

export const saveBuyNowIntent = (
  intent: Omit<BuyNowIntent, "createdAt">,
): void => {
  setCookie(
    BUY_NOW_INTENT_COOKIE,
    { ...intent, createdAt: Date.now() },
    BUY_NOW_INTENT_COOKIE_DAYS,
  );
};

export const getBuyNowIntent = (): BuyNowIntent | null => {
  const rawIntent = getCookieRaw(BUY_NOW_INTENT_COOKIE);
  if (!rawIntent) return null;

  try {
    const parsedIntent = JSON.parse(rawIntent);
    if (!isBuyNowIntent(parsedIntent)) {
      clearBuyNowIntent();
      return null;
    }

    if (Date.now() - parsedIntent.createdAt > BUY_NOW_INTENT_MAX_AGE_MS) {
      clearBuyNowIntent();
      return null;
    }

    return parsedIntent;
  } catch {
    clearBuyNowIntent();
    return null;
  }
};

export const clearBuyNowIntent = (): void => {
  deleteCookie(BUY_NOW_INTENT_COOKIE);
};
getBuyNowIntent()